import axios from 'axios'
import { toast } from 'react-toastify';

let apiUrl = process.env.REACT_APP_API_URL;

export const getAsync = async (path, showError = true, headers = null) => {

    try {
        // Extra headers for this request only (e.g. a document's Language, ADR-0045).
        const response = await axios.get(`${apiUrl}${path}`, headers ? { headers } : undefined);
        return { data: response.data, isSuccess: isResponseSuccess(response.status) };
    } catch (error) {
        throwError(error, showError);
        return { isSuccess: false, message: error && error.response && error.response.data && error.response.data.message };
    }
}

export const postAsync = async (path, data, showError = true, headers = null) => {

    try {
        const response = await axios.post(`${apiUrl}${path}`, data, headers ? { headers } : undefined);
        return { data: response.data, isSuccess: isResponseSuccess(response.status) };
    } catch (error) {
        throwError(error, showError);
        return { isSuccess: false, message: error && error.response && error.response.data && error.response.data.message };
    }
}

export const putAsync = async (path, data, showError = true) => {

    try {
        const response = await axios.put(`${apiUrl}${path}`, data);
        return { data: response.data, isSuccess: isResponseSuccess(response.status) };
    } catch (error) {
        throwError(error, showError);
        return { isSuccess: false, message: error && error.response && error.response.data && error.response.data.message };
    }
}

export const patchAsync = async (path, data, showError = true) => {

    try {
        const response = await axios.patch(`${apiUrl}${path}`, data);
        return { data: response.data, isSuccess: isResponseSuccess(response.status) };
    } catch (error) {
        throwError(error, showError);
        return { isSuccess: false, message: error && error.response && error.response.data && error.response.data.message };
    }
}

export const deleteAsync = async (path, showError = true) => {

    try {
        const response = await axios.delete(`${apiUrl}${path}`);
        return { data: response.data, isSuccess: isResponseSuccess(response.status) };
    } catch (error) {
        throwError(error, showError);
        return { isSuccess: false, message: error && error.response && error.response.data && error.response.data.message };
    }
}

// Promise-based upload to a signed URL: resolves `{ isSuccess }` instead of
// calling back, so a caller can await one file after another and report each.
export const putFileAsync = async (url, file, showError = true, onProgress = null) => {
    try {
        const config = { headers: { 'Content-Type': file.type } };
        if (typeof onProgress === 'function') config.onUploadProgress = onProgress;
        const response = await axios.put(url, file, config);
        return { isSuccess: isResponseSuccess(response.status) };
    } catch (error) {
        if (showError) toast.error(`${error}`);
        return { isSuccess: false };
    }
}

export const uploadAsync = async (url, data, successFunc, errorFunc, showError = true) => {
    const config = {
        headers: {
            'Content-Type': data.file.type
        }
    }

    axios.put(url, data.file, config)
        .then(response => {
            if (isResponseSuccess(response.status))
                successFunc(data.id);
        })
        .catch(error => {
            //errorFunc(data.id)
            if (showError) {
                toast.error(`${error}`);
            }
        });
}

export const upload = async (url, data, showError = true) => {
    const config = {
        headers: {
            'Content-Type': data.file.type
        }
    }

    await axios.put(url, data.file, config)
        .then(response => {
            return response;
        })
        .catch(error => {
            if (showError) {
                toast.error(`${error}`);
            }
        });
}

const isResponseSuccess = (status) => {
    return status >= 200 && status < 300;
}

const throwError = (error, showError) => {
    var message = `${error && error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Bir Hata Oluştu'}`;
    if (showError) {
        toast.error(message);
    }
    else {
        console.log(message)
    }
}